var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoToChina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.13,31.19c0,3.45-5.92,6.25-9.38,6.25H39.59L29.32,55.41c-0.28,0.49-0.8,0.79-1.36,0.79h-6.4 c-1.04,0-1.79-0.99-1.5-1.99l4.79-16.76H14.81l-4.22,5.63c-0.29,0.39-0.76,0.63-1.25,0.63H5.44c-1.02,0-1.76-0.96-1.52-1.94 L7,31.19L3.92,20.64c-0.25-0.99,0.5-1.94,1.52-1.94h3.91c0.49,0,0.96,0.23,1.25,0.63l4.22,5.63h10.04L20.07,8.19 c-0.29-1,0.46-1.99,1.5-1.99h6.4c0.5,0,1.11,0.35,1.36,0.79l10.26,17.96h11.16C54.2,24.94,60.13,27.74,60.13,31.19z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToChina);
export default __webpack_public_path__ + "static/media/go_to_china.628c12b6feb68b54cb43cf891e9b563c.svg";
export { ForwardRef as ReactComponent };